import { Routes } from '@angular/router';
import { provideNewsItemStore } from '@app/store/news-item';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const newsModalRoutes: Routes = [
    {
        path: 'news/add',
        component: ModalComponent,
        outlet: 'modal',
        providers: [...provideNewsItemStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'news/view/:id',
        component: ModalComponent,
        outlet: 'modal',
        providers: [...provideNewsItemStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'news/edit/:id',
        component: ModalComponent,
        outlet: 'modal',
        providers: [...provideNewsItemStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
